export interface formForAddIProps {
  type: "input" | "datePicker";
  /** Имя поля формы; подпись берётся из ключа listRequisites.<name> */
  name: string;
}

export const FORM_FOR_ADD: formForAddIProps[] = [
  { type: "input", name: "companyName" },
  { type: "input", name: "fullCompanyName" },
  { type: "input", name: "inn" },
  { type: "input", name: "ogrn" },
  { type: "input", name: "ogrn_number" },
  { type: "datePicker", name: "ogrn_date" },
  { type: "input", name: "kpp" },
  { type: "input", name: "okved" },
  { type: "input", name: "legalAddress" },
  { type: "input", name: "postalAddress" },
  { type: "input", name: "bankName" },
  { type: "input", name: "bik" },
  { type: "input", name: "correspondentAccount" },
  { type: "input", name: "paymentAccount" },
  // поля startDate пока нет в схеме бэкенда (см. комментарий ниже)
  { type: "datePicker", name: "startDate" },
  { type: "input", name: "phone" },
  { type: "input", name: "fax" },
  { type: "input", name: "email" },
];

export const defaultValueField = {
  companyName: "",
  fullCompanyName: "",
  inn: "",
  kpp: "",
  ogrn: "",
  legalAddress: "",
  postalAddress: "",
  paymentAccount: "",
  bankName: "",
  correspondentAccount: "",
  bik: "",
  phone: "",
  fax: "",
  okved: "",
  email: "",
  ogrn_date: new Date(),
  ogrn_number: "",
};
